import { FiltersQuery } from "../../../types/PreConFilterQuery.interface";
import { Popover, Transition } from "@headlessui/react";
import { BiChevronDown } from "react-icons/bi";
import { ParsedUrlQuery } from "querystring";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";

const Checkable = dynamic(() => import("../../../components/Checkable"), {
  suspense: true,
});
interface TypeFiltersProps {
  query: FiltersQuery;
  push: (query: ParsedUrlQuery) => void;
}

const estimatedOption = [
  {
    label: "2023",
    value: "2023",
    id: "1",
  },
  {
    label: "2024",
    value: "2024",
    id: "2",
  },
  {
    label: "2025",
    value: "2025",
    id: "3",
  },
  {
    label: "2026",
    value: "2026",
    id: "4",
  },
  {
    label: "2027",
    value: "2027",
    id: "5",
  },
  {
    label: "2028",
    value: "2028",
    id: "6",
  },
  {
    label: "2029",
    value: "2029",
    id: "7",
  },
  {
    label: "2030",
    value: "2030",
    id: "8",
  },
];

const OccupancyFilters: React.FC<TypeFiltersProps> = ({ query, push }) => {
  return (
    <Popover>
      <Popover.Button className="flex gap-2 justify-center items-center outline-none border-none text-sm">
        <>
          Occupancy <BiChevronDown size={15} />
        </>
      </Popover.Button>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="bg-white border border-black border-opacity-5 absolute rounded-sm text-black px-3 py-2 flex flex-col gap-3 w-full left-0 md:left-auto md:w-40">
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <Checkable
              className="w-full"
              options={estimatedOption}
              value={query.occupancy}
              onChange={(tags) => {
                push({
                  occupancy: tags,
                  page: "1",
                });
              }}
            />
          </Suspense>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default OccupancyFilters;
